import { useState } from "react";
import { Link, useLocation } from "wouter";
import { apiLogin } from "../lib/api";

export function Login() {
  const [, setLocation] = useLocation();
  const [zid, setZid] = useState("");
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    try {
      const r = await apiLogin(zid, pw);
      if (!r.ok) {
        setErr(r.error ?? "Login failed.");
        return;
      }
      setLocation("/app/dashboard");
    } catch (e: unknown) {
      setErr(e instanceof Error ? e.message : "Login error.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="min-h-[100dvh] bg-app grid lg:grid-cols-2">
      <section className="hidden lg:flex bg-nomni-deep text-cream p-12 flex-col justify-between">
        <Link href="/" className="font-display italic text-2xl flex items-center gap-2">
          <span className="size-7 rounded-md bg-nomni" />
          Nomni
        </Link>
        <div>
          <h1 className="text-5xl tracking-tight text-balance">
            Welcome back. Your <span className="font-display italic">procurement</span> is online.
          </h1>
          <p className="mt-5 text-cream/70 max-w-md text-pretty">
            Same Zeemart credentials, brand new agent-native shell.
            Your session lives in a Cloudflare Worker, never in the browser.
          </p>
        </div>
        <div className="text-xs text-cream/60">
          Not a buyer.zeemart.co customer? <a className="underline" href="https://buyer.zeemart.co/buyer-signup">Sign up at Zeemart</a> first, then come back here.
        </div>
      </section>

      <section className="grid place-items-center px-8 py-12">
        <form onSubmit={onSubmit} className="w-full max-w-sm space-y-5 rise">
          <div>
            <h2 className="text-3xl tracking-tight">Sign in</h2>
            <p className="text-ink-mute mt-1 text-sm">with your Zeemart buyer account.</p>
          </div>
          <label className="block">
            <span className="text-xs uppercase tracking-[0.16em] text-ink-mute">Zeemart ID (email)</span>
            <input
              type="email"
              required
              autoFocus
              autoComplete="email"
              value={zid}
              onChange={(e) => setZid(e.target.value)}
              className="mt-1 w-full rounded-lg border border-rule bg-panel px-3 py-2 text-ink focus:outline-none focus:ring-2 focus:ring-nomni"
              placeholder="you@restaurant.sg"
            />
          </label>
          <label className="block">
            <span className="text-xs uppercase tracking-[0.16em] text-ink-mute">Password</span>
            <input
              type="password"
              required
              autoComplete="current-password"
              value={pw}
              onChange={(e) => setPw(e.target.value)}
              className="mt-1 w-full rounded-lg border border-rule bg-panel px-3 py-2 text-ink focus:outline-none focus:ring-2 focus:ring-nomni"
            />
          </label>
          {err ? <div className="text-sm text-danger bg-danger-soft/40 px-3 py-2 rounded">{err}</div> : null}
          <button
            type="submit"
            disabled={busy}
            className="w-full rounded-full bg-nomni-deep text-white py-3 font-medium hover:bg-nomni-leaf disabled:opacity-60"
          >
            {busy ? "Signing in..." : "Sign in"}
          </button>
          <p className="text-xs text-ink-mute text-center">
            By signing in you accept Zeemart's terms — your session token is held only by our worker.
          </p>
        </form>
      </section>
    </main>
  );
}
